import { tv } from 'tailwind-variants';

const sliderThumbStyles = tv({
    base: `
    iris:block
    iris:size-(--comp-size-box-slider-handle)
    iris:cursor-pointer
    iris:touch-none
    iris:rounded-(--comp-size-radius-slider-handle)
    iris:border-(length:--comp-size-border-slider-handle)
    iris:border-(--comp-color-border-slider-handle-rest)
    iris:bg-(--comp-color-background-slider-handle-rest)
    iris:transition-all
    iris:duration-(--comp-motion-duration-slider)
    iris:outline-none
    iris:hover:bg-[linear-gradient(var(--comp-color-background-slider-handle-hover),var(--comp-color-background-slider-handle-hover))]
    iris:active:border-(--comp-color-border-slider-handle-pressed)
    iris:active:bg-[linear-gradient(var(--comp-color-background-slider-handle-pressed),var(--comp-color-background-slider-handle-pressed))]
  `,
    variants: {
        inverse: {
            true: `
        iris:border-(--comp-color-border-slider-handle-inverse-rest)
        iris:bg-(--comp-color-background-slider-handle-inverse-rest)
        iris:hover:border-(--comp-color-border-slider-handle-inverse-hover)
        iris:hover:bg-[linear-gradient(var(--comp-color-background-slider-handle-inverse-hover),var(--comp-color-background-slider-handle-inverse-hover))]
        iris:active:border-(--comp-color-border-slider-handle-inverse-pressed)
        iris:active:bg-[linear-gradient(var(--comp-color-background-slider-handle-inverse-pressed),var(--comp-color-background-slider-handle-inverse-pressed))]
      `,
        },
        focusRing: {
            true: `
        iris:ring-2
        iris:ring-(--sem-color-border-interactive-selected)
        iris:ring-offset-2
        iris:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
      `,
            false: "",
        },
        inverseFocusRing: {
            true: `
        iris:ring-(--sem-color-border-interactive-inverse-selected)
        iris:ring-offset-(--sem-color-background-neutral-inverse-primary)
      `,
            false: "",
        },
    },
    compoundVariants: [
        {
            inverse: true,
            focusRing: true,
            class: "iris:ring-(--sem-color-border-interactive-inverse-selected)",
        },
        {
            inverse: true,
            focusRing: true,
            class: "iris:ring-offset-(--sem-color-background-neutral-inverse-primary)",
        },
    ],
    defaultVariants: {
        inverse: false,
        focusRing: false,
        inverseFocusRing: false,
    },
});

export { sliderThumbStyles as default };
